import React from 'react';

const Faq = (props) => {
const dataPrintSidebarTitle = props.CurrentPageProps?.Content?.Translations?.qablock || '';
  return (
    <div className="c-faq" data-print-sidebar-title={dataPrintSidebarTitle}>
      <h2 className="c-faq__meta">{props.Translations.question}</h2>
      <div
        className="c-chapter"
        dangerouslySetInnerHTML={{ __html: props.Question }}
      ></div>
      <h2 className="c-faq__meta">{props.Translations.answer}</h2>
      <div
        className="c-chapter"
        dangerouslySetInnerHTML={{ __html: props.Answer }}
      ></div>
      {props.RespondedBy && (
        <div className="c-chapter">
          <p className="c-faq__responder">{props.RespondedBy}</p>
        </div>
      )}
    </div>
  );
};

export default Faq;
